import React from "react";
import ReactQuill, { ReactQuillProps } from "react-quill";
import "react-quill/dist/quill.snow.css";
import styled from "styled-components";
import { COLORS } from "styles/colors";
import { calcRem } from "styles/theme";

export const EditorContainer = styled.div`
  width: 100%;

  .quill {
    width: 100%;
    background-color: ${COLORS.WHITE};
  }
  .ql-editor {
    min-height: 200px;
    max-height: 200px;
    color: ${COLORS.BLACK};
  }
  .ql-snow .ql-picker {
    font-size: ${calcRem(14)};
  }

  .quill > .ql-container > .ql-editor.ql-blank::before {
    font-size: ${calcRem(14)};
    color: #abb5c5;
    font-style: normal;
  }
`;

function QuillEditor(props: ReactQuillProps): JSX.Element {
  const modules = React.useMemo(
    () => ({
      toolbar: {
        // container에 등록되는 순서대로 tool 배치
        container: [
          [
            "bold",
            "italic",
            "underline",
            "strike",
            "blockquote",
            "code-block",
            "formula",
            "link",
          ], // 굵기, 기울기, 밑줄 등 부가 tool 설정
          ["clean"], // toolbar 설정 초기화 설정
        ],
      },
    }),
    []
  );

  // toolbar에 사용되는 tool format
  const formats = [
    "font",
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "code-block",
    "formula",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
    "align",
    "color",
    "background",
  ];

  return (
    <ReactQuill theme="snow" modules={modules} formats={formats} {...props} />
  );
}

export default QuillEditor;
